// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1150":"4f13d5e3","6243":"626a9a7d"}[chunkId] + ".chunk.css";
};